import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogContent } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CartService } from '../../../../../_services/cart.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-klarna-modal',
    imports: [MatDialogContent, MatButtonModule],
    templateUrl: './klarna-modal.component.html',
    styleUrl: './klarna-modal.component.css'
})
export class KlarnaModalComponent implements OnInit{
  readonly dialogRef = inject(MatDialogRef<KlarnaModalComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  klarnaSnippet: string = '';
  klarnaIframeUrl: SafeResourceUrl = '';
  klarnaStatus: string = 'PENDING';

  constructor(private sanitizer: DomSanitizer, private cartService: CartService) {}

  ngOnInit(): void {
    this.klarnaSnippet =  this.data.html_snippet;
    const blob = new Blob([this.klarnaSnippet], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    this.klarnaIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.cartService.klarnaStatus$.subscribe((status) => {
      console.log(status);
      this.klarnaStatus = status;
    });
  }

}
